import React from 'react'

import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import Login from './Login'
import { login, toggleLoginError } from './auth-reducer'
import Snackbar from 'material-ui/Snackbar'
import IconButton from 'material-ui/IconButton'
import CloseIcon from 'material-ui-icons/Close'

const LoginContainer = ({
  user,
  redirect,
  login,
  location,
  authenticationFailed,
  toggleLoginError
}) => {
  const { from } = location.state || { from: { pathname: '/' } }

  if (user.name || redirect) {
    return <Redirect to={from} />
  }

  return <div>
    <Login onLogin={login} />
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      open={authenticationFailed || false}
      onClose={toggleLoginError}
      autoHideDuration={6000}
      SnackbarContentProps={{
        'aria-describedby': 'message-id'
      }}
      message={<span id='message-id'>Login failed. Please try with correct credentials.</span>}
      action={[
        <IconButton
          key='close'
          aria-label='Close'
          color='inherit'
          onClick={toggleLoginError}
        >
          <CloseIcon />
        </IconButton>
      ]}
    />
  </div>
}

const mapDispatchToProps = {
  login,
  toggleLoginError
}

const mapStateToProps = ({auth: { user, redirect, authenticationFailed }}) => ({ user, redirect, authenticationFailed })

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)



// WEBPACK FOOTER //
// ./src/login/LoginContainer.js